import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Button, Container, Table } from "react-bootstrap";
import { connect } from "react-redux";
import { GetKmBadPings } from '../../../store/actions/reports/km-bad-pings';
import { GetSubsRnNums } from '../../../store/actions/vehicle/vehicle.js';
import api from "../../../service/api";
import API_BOOK from "../../../service/endpoints";
import { exportToExcel } from "../../../utils/export-to-excel";
import { getFormattedDate } from "../../../utils/common-methods";
import Loader from "../../helpers/hoc/loader/Loader";
import MultiSelect from "../../helpers/hoc/multi-select/MultiSelect";
import NoRecordFound from "../../helpers/hoc/noRecordFound";
import Pagination from "../../helpers/hoc/paginator/Pagination";
import Filters from '../new-report/report-charging/child-components/Filters';
import "./css/HistoricDetails.css";

const KmBadPings = ({
  GetKmBadPings,
  GetSubsRnNums,
  subcribedRnNums,
  allKmBadPings,
  dataCount,
  isLoading,
}) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isRnFilterWarnEnabled, setIsRnFilterWarnEnabled] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isDtFilterWarnEnabled, setIsDtFilterWarnEnabled] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 8;

  useEffect(() => {
    if (subcribedRnNums.length === 0) {
      GetSubsRnNums();
    }
  }, [GetSubsRnNums, subcribedRnNums]);

  useEffect(() => {
    if (dataCount > 0) {
      GetKmBadPings({
        registrationNumbers: selectedOptions,
        fromDate: startDate,
        toDate: endDate,
        pageIndex: currentPage - 1,
        pageSize: ITEMS_PER_PAGE,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  function toLocalDate(isoStr) {
    const d = new Date(isoStr);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  function onDateChangeHandler({ startDate, endDate }) {
    allKmBadPings.length = 0;
    const from = toLocalDate(startDate);
    const to = toLocalDate(endDate);
    setStartDate(from);
    setEndDate(to);
    setCurrentPage(1);
    if (selectedOptions && selectedOptions.length > 0) {
      GetKmBadPings({
        registrationNumbers: selectedOptions,
        fromDate: from,
        toDate: to,
        pageIndex: 0,
        pageSize: ITEMS_PER_PAGE,
      });
    }
  }

  function onSelectionChange() {
    allKmBadPings.length = 0;
  }

  const onSubmitHandler = () => {
    if (!selectedOptions?.length && !endDate && !startDate) {
      setIsRnFilterWarnEnabled(true);
      setIsDtFilterWarnEnabled(true);
      setTimeout(() => {
        setIsRnFilterWarnEnabled(false);
        setIsDtFilterWarnEnabled(false);
      }, 2000);
      return;
    } else if (!selectedOptions?.length) {
      setIsRnFilterWarnEnabled(true);
      setTimeout(() => { setIsRnFilterWarnEnabled(false); }, 2000);
      return;
    } else if (!(endDate && startDate)) {
      setIsDtFilterWarnEnabled(true);
      setTimeout(() => { setIsDtFilterWarnEnabled(false); }, 2000);
      return;
    }
    setCurrentPage(1);
    GetKmBadPings({
      registrationNumbers: selectedOptions,
      fromDate: startDate,
      toDate: endDate,
      pageIndex: 0,
      pageSize: ITEMS_PER_PAGE,
    });
    setTimeout(() => { setIsSubmitClicked(true); }, 1000);
  };

  const handleExportExcel = async () => {
    try {
      const { GET_KM_BAD_PINGS } = API_BOOK.REPORTS.KM_REPORT;
      const resp = await api({
        method: GET_KM_BAD_PINGS.method,
        url: GET_KM_BAD_PINGS.url,
        data: {
          registrationNumbers: selectedOptions?.map((val) => val.label),
          fromDate: startDate,
          toDate: endDate,
          pageSize: 0,
          pageIndex: 0,
        }
      });
      if (resp.status === 200 && resp?.data?.data?.rows?.length) {
        const rows = resp.data.data.rows;
        const headers = [
          { header: 'S.No', key: 'sno', width: 8 },
          { header: 'Registration No', key: 'rn', width: 18 },
          { header: 'OEM', key: 'oem', width: 12 },
          { header: 'Date', key: 'date', width: 12 },
          { header: 'Prev Timestamp', key: 'prevTs', width: 22 },
          { header: 'Bad Timestamp', key: 'badTs', width: 22 },
          { header: 'Prev OD', key: 'prevOd', width: 12 },
          { header: 'Bad OD', key: 'badOd', width: 12 },
          { header: 'OD Diff', key: 'odDiff', width: 12 },
          { header: 'Time Gap (min)', key: 'gapMin', width: 14 },
          { header: 'Max Possible', key: 'maxPossible', width: 14 },
          { header: 'Excess KM', key: 'excessKM', width: 12 },
          { header: 'Reason', key: 'reason', width: 15 },
          { header: 'Calculation', key: 'calculation', width: 20 },
        ];
        const data = rows.map((n, i) => ({
          sno: i + 1,
          rn: n.rn || '-',
          oem: n.oem || '-',
          date: n.date || '-',
          prevTs: n.prevTs ? getFormattedDate(n.prevTs) : '-',
          badTs: n.badTs ? getFormattedDate(n.badTs) : '-',
          prevOd: n.prevOd != null ? Number(n.prevOd.toFixed(2)) : '-',
          badOd: n.badOd != null ? Number(n.badOd.toFixed(2)) : '-',
          odDiff: n.odDiff != null ? Number(n.odDiff.toFixed(2)) : '-',
          gapMin: n.gapMin != null ? Number(n.gapMin.toFixed(2)) : '-',
          maxPossible: n.maxPossible != null ? Number(n.maxPossible.toFixed(2)) : '-',
          excessKM: n.excessKM != null ? Number(n.excessKM.toFixed(2)) : '-',
          reason: n.reason || '-',
          calculation: n.calculation || '-',
        }));
        exportToExcel({ data, headers, fileName: 'KM_Bad_Pings.xlsx', sheetName: 'Bad Pings' });
      }
    } catch (error) {
      console.log('Export error:', error);
    }
  };

  return (
    <>
      <Container fluid>
        <div className="col-12 historic-details-filter-layout">
          <div className={`multi-select-width ${!selectedOptions[0] ? 'no-value-selected' : ''}`}>
            <MultiSelect
              isMultiSelect={true}
              setNoDataWarning={isRnFilterWarnEnabled}
              options={subcribedRnNums}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              onChange={onSelectionChange}
              placeholderColor='#C6C6C6'
              customBackgroundColor={{ backgroundColor: selectedOptions[0] ? "#FFFFFF" : "red" }}
            />
          </div>
          <div>
            <Button
              className="bttn height"
              id="getReport"
              type="submit"
              onClick={onSubmitHandler}
              disabled={!selectedOptions?.length || !endDate || !startDate}
            >
              Get Report
            </Button>
          </div>
          <div>
            <button
              disabled={!allKmBadPings?.length || !selectedOptions?.length || !endDate || !startDate}
              className={
                !allKmBadPings?.length || !selectedOptions?.length || !endDate || !startDate
                  ? "dwn-btn dwn-btn-disabled"
                  : "dwn-btn"
              }
              onClick={handleExportExcel}
            >
              <BsDownload style={{ width: '22px', height: '22px' }} />
            </button>
          </div>
          <div className='col-4 date__picker'>
            <Filters onDateChangeHandler={onDateChangeHandler}></Filters>
          </div>
        </div>

        {allKmBadPings?.length ? (
          <div className="bg-white mb-2 mt-4 position-relative trip__log__table historic-details-table-wrapper">
            <Table responsive={true} borderless className="mb-0" id="km-bad-pings-table">
              <thead>
                <tr className="th-border-bottom position-relative">
                  <th className="ps-2 text-nowrap"><p className="fw500">S.No</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Registration No</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">OEM</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Date</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Prev Timestamp</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Bad Timestamp</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Prev OD</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Bad OD</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">OD Diff</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Time Gap<br />(min)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Max Possible</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Excess KM</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Reason</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Calculation</p></th>
                </tr>
              </thead>
              <tbody>
                {allKmBadPings?.map((n, index) => (
                  <tr key={index}>
                    <td>{index + 1 + ((currentPage - 1) * ITEMS_PER_PAGE) + "."}</td>
                    <td>{n?.rn || '-'}</td>
                    <td>{n?.oem || '-'}</td>
                    <td>{n?.date || '-'}</td>
                    <td>{n?.prevTs ? getFormattedDate(n.prevTs) : '-'}</td>
                    <td>{n?.badTs ? getFormattedDate(n.badTs) : '-'}</td>
                    <td>{n?.prevOd != null ? n.prevOd.toFixed(2) : '-'}</td>
                    <td>{n?.badOd != null ? n.badOd.toFixed(2) : '-'}</td>
                    <td>{n?.odDiff != null ? n.odDiff.toFixed(2) : '-'}</td>
                    <td>{n?.gapMin != null ? n.gapMin.toFixed(2) : '-'}</td>
                    <td>{n?.maxPossible != null ? n.maxPossible.toFixed(2) : '-'}</td>
                    <td>{n?.excessKM != null ? n.excessKM.toFixed(2) : '-'}</td>
                    <td>{n?.reason || '-'}</td>
                    <td>{n?.calculation || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Pagination
              disabled={false}
              totalPages={Math.ceil((dataCount || 0) / ITEMS_PER_PAGE)}
              currentPage={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        ) : (
          <></>
        )}
        {!allKmBadPings?.length && isSubmitClicked && !isLoading ? (
          <NoRecordFound></NoRecordFound>
        ) : (
          <></>
        )}
      </Container>
      <Loader isLoading={isLoading} />
    </>
  );
};

KmBadPings.propTypes = {
  allKmBadPings: PropTypes.array.isRequired,
  subcribedRnNums: PropTypes.array.isRequired,
  dataCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  GetKmBadPings: PropTypes.func.isRequired,
  GetSubsRnNums: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  allKmBadPings: state.kmBadPings.allKmBadPings,
  subcribedRnNums: state.vehicle.subcribedRnNums,
  dataCount: state.kmBadPings.dataCount,
  isLoading: state.loader.isLoading,
});

export default connect(mapStateToProps, {
  GetKmBadPings,
  GetSubsRnNums,
})(KmBadPings);
